import Select from '@mui/material/Select';

import Button from 'components/ui/Button';
import ContentCard from 'components/ui/ContentCard';
import { ThinHeadline } from 'components/ui/Headline';
import LogoBackground from 'components/ui/LogoBackground';
import React from 'react';
import styled from 'styled-components';
import { Row } from 'ui';

export const Dropdown = styled(Select)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ theme: { getColor, EColors } }) => getColor(EColors.pureWhite)};
    border: solid 1px ${({ theme: { getColor, EColors } }) => getColor(EColors.lightGrey)};
    border-radius: 8px;
    height: 43px;
    min-width: 103px;
    outline: none;
    font-size: 15px;
    padding: 0 16px;
    cursor: pointer;
    width: 100%;
    margin: 0.5rem 0;

    &:before {
        border-bottom: none !important;
    }

    &:after {
        border-bottom: none !important;
    }

    .MuiSelect-selectMenu.MuiSelect-selectMenu {
        background: ${({ theme: { getColor, EColors } }) => getColor(EColors.pureWhite)};
    }

    .MuiSelect-icon {
        position: initial;
    }
`;

export const UncasedHeadline = styled(ThinHeadline)<{ fontSize?: number; fontWeight?: number }>`
    text-transform: unset;
    margin: 0;
    ${({ fontSize }) => fontSize && `font-size: ${fontSize}px`};
    ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight}`};
    line-height: 24px;
    white-space: unset;
`;

export const EndRow = styled(Row)`
    align-items: flex-end;

    margin-top: 20px;
`;

export const InlineButtonRight = styled(Button)`
    display: block;
    margin-left: auto;
    ${({ width }) => width && `width: ${width}${typeof width === 'number' ? 'px' : ''}`};
`;

export const BizlyLogoPageWithCard = ({ heading = '', children }: { heading?: string; children?: React.ReactNode }) => {
    return (
        <LogoBackground>
            <ContentCard headlineCopy={heading}>{children}</ContentCard>
        </LogoBackground>
    );
};
